import { connect } from 'react-redux';
import SpeakerAudioSwitch from './ScribeSpeakerAudioSwitch';
import { updateSpeakerListened } from '../../actions';
export default connect((state) => ({
    status: state.scribeConversation.status,
    scribe: !!state.scribeConversation.scribe,
    speakerListened: state.scribeConversation.speakerListened,
}), {
    updateSpeakerListened,
})(SpeakerAudioSwitch);
